module.exports = __webpack_public_path__ + "img/preto2.4b83e57a.png";